import Icon from "../../components/selfcare/Icon.tsx";
import OrderAddressSearchComponent from "../../components/order/OrderAddressSearchComponent.tsx";
import {Link} from "react-router-dom";
import {ALL_FIBER} from "../../components/coverageMap/CoverageMap.ts";
import ScrollToTop from "../../components/ScrollToTop.tsx";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import Routing from "../../Routing.ts";
import CoverageMapContainer from "../../components/coverageMap/CoverageMapContainer.tsx";
import IconArrow from "../../components/icons/IconArrow.tsx";

export default function DaekningskortPage() {
    ScrollToTop()
    useDatalayer()
    setTitleAndMetaDescription('Dækningskort over fibernet, 5G og coax internet','Med vores dækningskort kan du tjekke, hvilken internetforbindelse du kan få i dit område. Så altid din adresse op, for at se præcise muligheder og priser.')

    return (
        <>
            <section>
                <div className="content">
                    <div className="blurb">
                        <h1 className="heading heading--big">Dækningskort</h1>
                        <h2 className="heading heading--paragraph heading--small">
                            Se hvor vi leverer internet i Danmark
                        </h2>
                        <p>
                            <Link to={Routing.Broadband.Index} className="icon-link icon-link-left icon-link-rotate-180 back-link-widget %s">
                                <Icon component={IconArrow}/> <span className="text">Tilbage</span>
                            </Link>
                        </p>
                    </div>
                    <CoverageMapContainer regionPreset={ALL_FIBER} fiberMapOnly={false} static={false}/>
                    <p className="coverage-map-disclaimer">
                        Vi kan ikke garantere at kunne levere til alle adresser i de markerede områder.
                    </p>
                </div>
            </section>
            <section>
                <div className="content">
                    <p>
                        På vores dækningskort kan du kan se, hvor vi leverer internet via <Link to={Routing.Broadband.Fiber}>fibernet</Link>, <Link to={Routing.Broadband.Coax}>kabel-tv-stik</Link> og <Link
                        to={Routing.Broadband.TDC5G}>5G</Link>.
                        Vi leverer 5G-internet til 99,9% af befolkningen, hvor du får Danmarks bedste 5G-dækning.
                    </p>
                    <p>
                        Hvis du overvejer at få fibernet og er i tvivl om, at der er fiber i dit område, kan du også nemt bruge dækningskortet til at tjekke dette.
                        Du kan også sortere ud fra internetleverandør på fiber, hvis du ved, hvilken leverandør som er i dit område.
                        Vores internetleverandører graver kontinuerligt nye fiberkabler ned i jorden, så hold gerne løbende øje med, om der skulle dukke fiber op i dit område på fibernet-kortet.
                        Hvis du gerne vil have lynhurtigt fibernet i din bolig, kan du læse mere om en <Link to="/hjaelp/bestilling/fiber-installation">fibernet-installation</Link>.
                    </p>
                    <p>
                        Hvis du vil tjekke fordele og ulemper ved de forskellige internetforbindelser, kan du kigge på artiklen <Link to="/hjaelp/internet-og-wifi/hvilket-internet-skal-jeg-vaelge">sammenlign internetforbindelser</Link>.
                    </p>
                    <p>
                        Du kan også slå din adresse op nedenfor og se, hvilken hastighed og pris du kan få.
                    </p>
                </div>
                <div className="content content--narrow">
                    <h2 className="heading heading--montserrat heading--medium">
                        Tjek hvor hurtigt internet du kan få
                    </h2>
                    <OrderAddressSearchComponent/>
                </div>
            </section>
        </>
    )
}
